module.exports = __webpack_public_path__ + "staticcomp/img/share.cb89d98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/8/share.jpg
// module id = JHSi
// module chunks = 39